const topics = [
    "ACS - Acute Coronary Syndromes (non STEMI)",
    "ACS/AMI",
    "Alcohol Septal Ablation and treatments for Hypertrophic Cardiomyopathy",
    "AMI/STEMI - Acute Myocardial Infarction",
    "Angiography and QCA",
    "Angioplasty Overview and Outcomes",
    "Aortic Disease & Intervention",
    "Aortic Regurgitation",
    "Aortic Stenosis: Aortic Stenosis Basics and Balloon Aortic Valvuloplasty",
    "Aortic Stenosis: Imaging and Procedural Guidance",
    "Aortic Stenosis: Other",
    "Aortic Stenosis: Surgical AVR",
    "Aortic Stenosis: TAVR Complications - Prevention and Management",
    "Aortic Stenosis: TAVR Devices and Clinical Outcomes",
    "Aortic Stenosis: TAVR Special Situations (ViV, PPM, other)",
    "Aortic Stenosis: TAVR Technique Issues",
    "Arterial Disease",
    "Artherectomy and Plaque Modification (excluding thrombectomy)",
    "Atrial Fibrillation",
    "Cardiac and Vascular Surgery",
    "Cardiogenic Shock and Hemodynamic Support Devices",
    "Cardiology Fellow Issues",
    "Cath lab of the future",
    "Cell Therapy and Angiogenesis",
    "CKD Intervention and Contrast Nephropathy",
    "Clinical Science & Decision Making",
    "Complex PCI",
    "Complications - Congenital and Structural",
    "Complications - Coronary",
    "Complications - Peripheral",
    "Congenital Heart Disease - overview and other",
    "Congenital Heart Disease - PFO and ASD",
    "Congenital Heart Disease, Complex: Coarctation, PDA, VSD, coronary anomalies, AVF, other",
    "Controversies and Debates",
    "Coronary Devices & Ancillary Tools",
    "Coronary Imaging & Physiology",
    "Coronary Lesions - Bifurcations",
    "Coronary Lesions - Bypass Graft Intervention",
    "Coronary Lesions - Calcified and resistant",
    "Coronary Lesions - CTO",
    "Coronary Lesions - In-stent Restenosis and Stent Thrombosis",
    "Coronary Lesions - Left Main",
    "Coronary Lesions - Long Lesions and Diffuse Disease",
    "Coronary Lesions - Multivessel Disease",
    "Coronary Lesions - Other",
    "Coronary Lesions - Small Vessels",
    "Cost-effectiveness, Quality of Life and Reimbursement Issues",
    "CTO PCI",
    "Diabetes: Drugs and Revascularization",
    "Diversity including women's Health Issues",
    "Drug coated balloons and local drug delivery (non-stent based)",
    "Electrophysiology diagnosis and therapies (including pacemakers and defibrillators)",
    "Embolic Protection Devices",
    "FFR, IFR, QFR and Other Physiologic Lesion Assessment",
    "First In-human Studies",
    "Genomics/Proteomics and Gene Therapy",
    "Guidelines and Appropriateness criteria",
    "Heart Failure Therapies: Drugs and Devices",
    "Hybrid surgical and PCI revascularization",
    "Hypertension Therapies Including Renal Denervation",
    "Imaging Intravascular - IVUS",
    "Imaging Intravascular - OCT",
    "Imaging Intravascular - Other",
    "Imaging Intravascular - Spectroscopy",
    "Imaging Noninvasive: CT, MR, PET and Nuclear",
    "Imaging Noninvasive: Echo",
    "Inflammation and Infection",
    "Innovation..",
    "Interventional Heart Failure",
    "Interventions For Hypertension",
    "LAAO Techniques & Technologies",
    "Laser",
    "Left Atrial Appendage Exclusion",
    "Lipid Disorders and Management",
    "Miscellaneous and Other",
    "Mitral Disease & Intervention",
    "Mitral Regurgitation: Imaging and Procedural Guidance",
    "Mitral regurgitation: Mitraclip",
    "Mitral Regurgitation: MR Overviews, Drugs and CRT",
    "Mitral regurgitation: Non-MitraClip",
    "Mitral Regurgitation: Other",
    "Mitral Stenosis and Valvuloplasty",
    "Mitral valve disease: Surgical repair or replacement",
    "Mitral valve disease: Transcatheter replacement",
    "New Devices and Innovation",
    "Non-Obstructive CAD (ANOCA/MINOCA, SCAD)",
    "Nurse/Technician/technologist/Pa and non-physician topics",
    "Pharmacotherapy - Chronic anticoagulants (warfarin and newer agents)",
    "Pharmacotherapy - Chronic medical therapies (non hematologic)",
    "Pharmacotherapy - Complications",
    "Pharmacotherapy - General issues and miscellaneous",
    "Pharmacotherapy - GPIIb/IIIa inhibitors",
    "Pharmacotherapy - Procedural Anticoagulants",
    "Pharmacotherapy/ platelet inhibitors (non GPIIb/IIIa)",
    "Political, international and societal issues related to medicine",
    "Pre-clinical studies",
    "Pulmonary emboli and pulmonary hypertension therapies",
    "Pulmonary Embolism/Venous Thromboembolic Disease",
    "Pulmonary Hypertension, Thrombo-Embolism, and Catheter Therapies",
    "Pulmonic Valvular Disease",
    "PV - Acute Stroke Interventions",
    "PV - Carotid Intervention",
    "PV - Cerebral Intervention (excluding acute stroke)",
    "PV - Clinical Syndromes and Diagnosis",
    "PV - Iliac/SFA Intervention",
    "PV - Infrapopliteal and Critical Limb Ischemia",
    "PV - Miscellaneous and Other",
    "PV - Renal and Mesenteric Intervention",
    "PV - Thoracic and Abdomincal Aortic Endografts",
    "PV - Venous Disease and Intervention",
    "Regulatory Considerations",
    "Statistics and Trial Design",
    "Stents - Bare Metal",
    "Stents - Drug-eluting: Bioresorbable Scaffolds",
    "Stents - Drug-eluting: Meta-Analyses",
    "Stents - Drug-eluting: Novel Metallic DES",
    "Stents - Drug-eluting: Randomized Trials",
    "Stents - Drug-eluting: Registries",
    "Stents - Drug-Eluting: Restenosis",
    "Stents - Drug-Eluting: Stent Thrombosis",
    "Stents - Other",
    "Stroke and Stroke Prevention Therapies",
    "Thrombus/Thrombectomy (excludes atherectomy)",
    "Tricuspid Disease & Intervention",
    "Tricuspid Valvular Disease",
    "Vascular Access and Intervention - Femoral (includes closure devices)",
    "Vascular Access and Intervention - Transradial",
    "Vulnerable Plaque - Atherosclerosis and Mechanisms",
    "Vulnerable Plaque - Invasive detection",
    "Vulnerable Plaque - Noninvasive detection",
    "Vulnerable Plaque - Therapies",
]

export default topics
